import React, { useState } from 'react';
import { Button, Modal, Box } from '@mui/material';
import ProjectInfoFields from './ProjectInfoFields'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CreateNewProjectButton = ({ disabled = false }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({
      name: '',
      description: '',
    });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    if (!form.name.trim() || !form.description.trim()) {
      alert('Both "Name" and "Description" are required.');
      return;
    }

    try {
      const response = await axios.post('/projects/', {
        name: form.name,
        info: {"description": form.description}
      });

      console.log('Project created:', response.data);

      const projectId = response.data.id;
      navigate(`/projects/${projectId}/training_data`);

      handleClose();
    } catch (error) {
      console.error('Error creating project:', error.response?.data || error.message);
      alert(`Failed to create project: ${error.response?.data?.detail || error.message}`);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{
          borderRadius: '12px',
          backgroundColor: '#16a4b0',
          color: 'white',
          textTransform: 'none',
          fontSize: '16px',
          width: { xs: '90%', sm: 'auto' },
          ml: 2,
        }}
        onClick={handleOpen}
        disabled={disabled}
      >
        Create New Project
      </Button>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'white',
            p: 4,
            borderRadius: 3,
            width: { xs: '90%', sm: '40%' },
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          <ProjectInfoFields form={form} handleChange={handleChange} width='95%' />

        <Box
          sx={{
          padding: 2,
          width: '50%',
          mx: 'auto',
          mt: 3,
          display: 'flex',
          justifyContent: 'center',
          gap: 4,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontSize: '16px',
                width: '120px',
                color: '#16a4b0',
                borderColor: '#16a4b0',
                '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#16a4b0' },
            }}
            >
            Previous
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
                borderRadius: '12px',
                backgroundColor: '#16a4b0',
                color: 'white',
                textTransform: 'none',
                fontSize: '16px',
                width: '120px',
                '&:hover': { backgroundColor: '#00707c' },
            }}
            >
            Create
          </Button>
        </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CreateNewProjectButton;
